"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONTOLOGY_NODE_TITLE = exports.UN_CATEGORIZED_NODE_TITLE = void 0;
exports.UN_CATEGORIZED_NODE_TITLE = 'Uncategorized Bucket';
exports.ONTOLOGY_NODE_TITLE = 'Ontology';
